import {
  GET_SUBSCRIPTIONS,
  GET_SUBSCRIPTIONS_SUCCESS,
  GET_SUBSCRIPTIONS_ERROR,
  GET_SUBSCRIPTION,
  GET_SUBSCRIPTION_SUCCESS,
  GET_SUBSCRIPTION_ERROR,
  GET_SUBSCRIPTION_NEWSLETTERS,
  GET_SUBSCRIPTION_NEWSLETTERS_SUCCESS,
  GET_SUBSCRIPTION_NEWSLETTERS_ERROR,
} from "../../constants/actionTypes";
import selectn from "selectn";

const initialState = {
  isLoading: false,
  isFinished: false,
  isError: false,
  error: null,
  data: null,
  results: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_SUBSCRIPTIONS:
    case GET_SUBSCRIPTION_NEWSLETTERS: {
      return {
        ...state,
        isLoading: true,
        isFinished: false,
        isError: false,
        error: null,
      };
    }

    //if we're switching to a new subscription, wipe out old data
    case GET_SUBSCRIPTION: {
      return {
        isLoading: true,
        isFinished: false,
        isError: false,
        error: null,
        data: null,
        results: [],
      };
    }

    case GET_SUBSCRIPTION_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isFinished: true,
        data: {
          ...state.data,
          ...action.payload,
        },
      };
    }

    case GET_SUBSCRIPTIONS_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isFinished: true,
        results: action.payload,
      };
    }

    case GET_SUBSCRIPTION_NEWSLETTERS_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isFinished: true,
        data: {
          ...state.data,
          subscription_newsletters: {
            ...action.payload,
            results: (selectn("subscription_newsletters.results", state.data) || []).concat(action.payload.results),
          },
        },
      };
    }

    case GET_SUBSCRIPTION_ERROR:
    case GET_SUBSCRIPTIONS_ERROR:
    case GET_SUBSCRIPTION_NEWSLETTERS_ERROR: {
      return {
        ...state,
        isLoading: false,
        isFinished: true,
        isError: true,
        error: action.payload,
      };
    }

    default: {
      return state;
    }
  }
};
